import { HttpClient } from '@angular/common/http';
import {Injectable } from '@angular/core';
import { DlistDto, DlistFieldDto, environment as env, FormDto, GenDlist, GetFormMetadata_Request, OrtakService } from '@dabnet-kamu/libs/ui';
import { DataCoreService, GetDlist_Request, GetDlist_Response } from '@dabnet-kamu/libs/ui';
import { GenDlistColumn } from 'libs/gen/src/lib/models/gen.models';
import {BehaviorSubject, catchError, finalize, Observable, tap, throwError} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class DListService {

    errorResponse: string[] = ["hata deneme"];
    //dlistmetadata
    dListFormMetaData$: Observable<FormDto | null>;

    //DList
    private _dListGridControlsList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public dListGridControlsList$ = this._dListGridControlsList.asObservable();

    private _dListGrupFields: BehaviorSubject<DlistFieldDto[] | null> = new BehaviorSubject(null);
    public dListGrupFields$ = this._dListGrupFields.asObservable();

    //DListColumn
    private _dListColumnGridControlList: BehaviorSubject<DlistDto | null> = new BehaviorSubject(null);
    public dListColumnGridControlList$ = this._dListColumnGridControlList.asObservable();

    private _dListColumnGrupFieldsList: BehaviorSubject<DlistFieldDto[] | null> = new BehaviorSubject(null);
    public dListColumnGrupFields$ = this._dListColumnGrupFieldsList.asObservable();

    defaultDListColumnData: GenDlistColumn = new GenDlistColumn({});
    defaultDListData: GenDlist = new GenDlist({});


  constructor(private dataCoreService: DataCoreService,private _httpClient:HttpClient,
    private ortakService:OrtakService
  ) {}

  dListDataSource() {
    const dataSource = this.dataCoreService.getOData('GenDlist',[],undefined,'Id');
    dataSource.select([]);

    return dataSource;
  }

  insertGenDlist(data: any): Promise<any> {
    return this.dataCoreService.createDataStore('GenDlist', data,"Id");
  }
  updateGenDlist(data: any): Promise<any> {
    return this.dataCoreService.updateDataStore('GenDlist', data,"Id");
  }
  removeGenDlist(data: any): Promise<any> {
    return this.dataCoreService.removeDataStore('GenDlist', data,"Id");
  }

  insertGenDlistColumn(data: any): Promise<any> {
    return this.dataCoreService.createDataStore('GenDlistColumn', data,"Id");
  }
  updateGenDlistColumn(data: any): Promise<any> {
    return this.dataCoreService.updateDataStore('GenDlistColumn', data,"Id");
  }
  removeGenDlistColumn(data: any): Promise<any> {
    return this.dataCoreService.removeDataStore('GenDlistColumn', data,"Id");
  }

  getDlist(formName:string):any {
    const request=new GetDlist_Request({
      dListCode:formName
    })
     this._httpClient.post<GetDlist_Response>(`${env.lookupService}/System/GetDList`, request).pipe(
      tap(response => {
        if(formName === 'GenDlists'){
        this._dListGridControlsList.next(response.dListMetadata)
        this._dListGrupFields.next(response.dListMetadata.fields);
        }
        if(formName === 'GenDlistColumns'){
            this._dListColumnGridControlList.next(response.dListMetadata)
            this._dListColumnGrupFieldsList.next(response.dListMetadata.fields);
        }
      }),
      catchError(err => throwError(err)),
      finalize(() => {})
    ).subscribe();
  }

  dListColumnDataSource(Id:number) {
    const dataSource = this.dataCoreService.getOData('GenDlistColumn',[],undefined,'Id');
    dataSource.select([]);
    const filterArr = [
        ['DlistId', '=', Id]
      ];
      dataSource.filter(filterArr);
    return dataSource;
  }


}
